'use client'

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/lib/ui-kit/components/ui/Dialog.component'

interface RawDataModalProps {
  isOpen: boolean
  onClose: () => void
  data: any
}

export function RawDataModal({ isOpen, onClose, data }: RawDataModalProps) {
  if (!data) return null

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="flex max-h-[80vh] max-w-4xl flex-col">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Raw Metadata</DialogTitle>
        </DialogHeader>
        <div className="mt-4 flex-1 overflow-y-auto">
          <div className="rounded-lg bg-muted">
            <div className="overflow-x-auto">
              <pre className="m-0 p-4">
                <code className="block text-sm">
                  {JSON.stringify(data, null, 2)}
                </code>
              </pre>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
